import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Alert
} from '@mui/material';
import { updateServiceType } from '../../../services/serviceTypeService';

const EditServiceTypeDialog = ({ open, onClose, onEdit, initialData }) => {
  const [form, setForm] = useState({
    type_description: '',
    time_cost: '',
    charge: '',
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setForm({
        type_description: initialData.type_description || '',
        time_cost: initialData.time_cost || '',
        charge: initialData.charge || '',
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    try {
      await updateServiceType(initialData.id || initialData.type_id, form);
      onEdit(); // ✅ notify parent to re-fetch list
      onClose(); // ✅ close dialog
    } catch (err) {
      const msg = err.response?.data
        ? Object.values(err.response.data).flat().join(', ')
        : 'Failed to update';
      setError(msg);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Service Type</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          name="type_description"
          label="Description"
          value={form.type_description}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          name="time_cost"
          label="Time Cost"
          value={form.time_cost}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          name="charge"
          label="Charge"
          type="number"
          value={form.charge}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={loading} variant="contained" color="primary">
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditServiceTypeDialog;
